import { JourneyStatusEnum } from '../../../modules/teacher/types';
import { DividerProps } from '../../atoms/Divider';
import { TeacherStatusTagProps } from '../../atoms/TeacherStatusTag';
import { TextProps } from '../../atoms/Text';
import { LabelTextGroupProps } from '../../molecules/LabelTextGroup';
import { ActionSectionProps } from '../ActionSection';


type DashboardInfoSectionInternalProps = {
  text?: TextProps;
  divider?: DividerProps;
  text1?: TextProps;
  teacherStatusTag?: TeacherStatusTagProps;
  labelTextGroup?: LabelTextGroupProps;
  actionSection?: ActionSectionProps;
};

type DashboardInfoSectionPropsValues = {
  '': DashboardInfoSectionInternalProps;
};

const propValues: DashboardInfoSectionPropsValues = {
  '': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading3',
    },
    divider: {
      type: 'Horizontal',
      style: 'Solid',
      colour: 'BorderBase',
    },
    text1: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Body1',
    },
    teacherStatusTag: {
      type: JourneyStatusEnum.in_training, //MANUAL OVERRIDE
    },
    labelTextGroup: {
      type: 'Horizontal',
    },
    actionSection: {
    },
  },
};

const getProps = (type: string): DashboardInfoSectionInternalProps => {
  const values: DashboardInfoSectionInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
